var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pause",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.954,
    height: 11.938,
    viewBox: "0 0 8.954 11.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M4.741,0A1.741,1.741,0,0,0,3,1.741V10.2a1.741,1.741,0,1,0,3.482,0V1.741A1.741,1.741,0,0,0,4.741,0Zm.746,10.2a.746.746,0,0,1-1.492,0V1.741a.746.746,0,1,1,1.492,0Z",
    fill: "#FFBF00",
    transform: "translate(-3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M15.741,0A1.741,1.741,0,0,0,14,1.741V10.2a1.741,1.741,0,0,0,3.482,0V1.741A1.741,1.741,0,0,0,15.741,0Zm.746,10.2a.746.746,0,0,1-1.492,0V1.741a.746.746,0,0,1,1.492,0Z",
    fill: "#FFBF00",
    transform: "translate(-8.528)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseProduct);
export default __webpack_public_path__ + "static/media/pauseProduct.8dadeab6b6a92f3bd84c02168285780a.svg";
export { ForwardRef as ReactComponent };